import React from 'react'

function AboutUsVision() {
    return (
        <>
            <div className='about-us-vision my-5'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-md-7'>
                            <img src="/images/two-business-partners-working-office.png" alt="" className='img-fluid' />
                        </div>
                        <div className='col-md-5 text-center text-md-start mt-3'>
                            <p className='about-us-mini-title mb-0'>OUR ONE BILLION MISSION</p>
                            <p className='about-us-title'>Our one billion mission sounds bold, We agree.</p>
                            <p className='about-us-description'>"We cannot solve our problems with the same thinking we used when we created them."—Albert Einstein.
                                Institutions are slow to change. Committees are where good ideas and innovative thinking go to die.
                                Choose agility over dogma. Embrace and drive change.
                                We need to wipe the slate clean and begin with bold, radical thinking.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutUsVision